var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 96,
    viewBox: "0 0 122 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no_share",
    "data-name": "no share",
    transform: "translate(20.748 -4.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transaction-history_2_",
    "data-name": "transaction-history (2)",
    transform: "translate(-22.748 2.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5261",
    "data-name": "Path 5261",
    d: "M87.556,15.72v80.6c0,1.372-2.039,2.058-3.4,1.029l-5.1-4.8a3.652,3.652,0,0,0-3.738,0l-5.1,4.116a5.06,5.06,0,0,1-6.117,0l-5.1-4.116a2.649,2.649,0,0,0-3.738,0l-5.1,4.116a5.572,5.572,0,0,1-6.457,0l-5.1-4.116a2.649,2.649,0,0,0-3.738,0l-5.1,4.116a5.572,5.572,0,0,1-6.457,0l-5.1-4.116a3.652,3.652,0,0,0-3.738,0l-5.1,4.8A1.951,1.951,0,0,1,6,96.323V2H72.944C80.76,2,87.556,8.174,87.556,15.72Z",
    transform: "translate(7.117 0)",
    fill: "#ecb2e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5262",
    "data-name": "Path 5262",
    d: "M13.118,2V21.178H4.779A2.989,2.989,0,0,1,2,18.4V13.118C2,7.281,7,2.278,13.118,2Z",
    transform: "translate(0)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(29.854 21.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5263",
    "data-name": "Path 5263",
    d: "M54.882,11H11.8A2.491,2.491,0,0,1,9.3,8.5,2.933,2.933,0,0,1,11.8,6h43.08a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-9.3 -6)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5264",
    "data-name": "Path 5264",
    d: "M54.882,16.3H11.8a2.5,2.5,0,1,1,0-5h43.08a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-9.3 3.431)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5265",
    "data-name": "Path 5265",
    d: "M54.882,21.6H11.8a2.5,2.5,0,1,1,0-5h43.08a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-9.3 12.861)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5266",
    "data-name": "Path 5266",
    d: "M54.882,26.9H11.8a2.5,2.5,0,0,1,0-5h43.08a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-9.3 22.292)",
    fill: "#90348a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(2.446 5.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5175",
    "data-name": "Path 5175",
    d: "M53.835,31.035,50.66,27.86A22.754,22.754,0,0,1,48.9,29.855,22.753,22.753,0,0,1,46.91,31.61l3.175,3.175a4.94,4.94,0,0,0,1.324,4.6l14.3,14.3a4.953,4.953,0,1,0,7-7l-14.3-14.3a4.819,4.819,0,0,0-4.579-1.34Z",
    transform: "translate(23.438 8.806)",
    fill: "#e1cce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 22.387,
    cy: 22.387,
    r: 22.387,
    transform: "translate(34.58)",
    fill: "#e1cce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5176",
    "data-name": "Path 5176",
    d: "M44.21,41.165A15.843,15.843,0,0,1,32.9,36.473a16.035,16.035,0,0,1,0-22.642,15.987,15.987,0,0,1,22.626,0,16.035,16.035,0,0,1,0,22.642A15.843,15.843,0,0,1,44.21,41.165Z",
    transform: "translate(12.796 -2.773)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872",
    transform: "translate(1.252 4.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5177",
    "data-name": "Path 5177",
    d: "M56.83,13.432A17.206,17.206,0,0,0,32.5,37.766a17.2,17.2,0,0,0,24.334,0,17.239,17.239,0,0,0,0-24.334ZM55.138,36.074a14.816,14.816,0,1,1,0-20.951A14.714,14.714,0,0,1,55.138,36.074Z",
    transform: "translate(13.544 -2.023)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5178",
    "data-name": "Path 5178",
    d: "M87.535,59.769l-14.3-14.3a6.137,6.137,0,0,0-5.026-1.755L66.2,41.706a23.677,23.677,0,1,0-5.441,5.425l2.011,2.011a6.086,6.086,0,0,0,1.755,5.026l14.3,14.3a6.155,6.155,0,1,0,8.712-8.7Zm-55.481-16.8a21.187,21.187,0,1,1,14.983,6.207A21.036,21.036,0,0,1,32.055,42.967ZM85.844,66.79a3.756,3.756,0,0,1-5.314,0l-14.3-14.3a3.779,3.779,0,0,1-1.005-3.479,1.173,1.173,0,0,0-.319-1.1l-2.266-2.266c.367-.319.734-.622,1.069-.973.351-.351.654-.718.973-1.069l2.266,2.266a1.173,1.173,0,0,0,1.1.319A3.728,3.728,0,0,1,71.547,47.2l14.3,14.3a3.728,3.728,0,0,1,1.1,2.665,3.656,3.656,0,0,1-1.1,2.633Z",
    transform: "translate(10.67 -4.4)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    "data-name": "Path 5182",
    d: "M46.1,15.78a1.2,1.2,0,0,0-1.691,0l-3.941,3.941L36.531,15.78a1.2,1.2,0,0,0-1.691,1.691l3.941,3.941L34.84,25.353a1.2,1.2,0,0,0,0,1.691,1.194,1.194,0,0,0,1.691,0L40.472,23.1l3.941,3.941a1.194,1.194,0,0,0,1.691,0,1.2,1.2,0,0,0,0-1.691l-3.941-3.941L46.1,17.471a1.176,1.176,0,0,0,0-1.691Z",
    transform: "translate(17.768 2.333)",
    fill: "#71207c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyShare);
export default __webpack_public_path__ + "static/media/icon_empty_share.25e4d1d58a02c68076a5a3d794c7229f.svg";
export { ForwardRef as ReactComponent };